import 'css-chunk:src/components/chip/chip-component.module.scss';export default {
  "chip-container": "chip-component_chip-container__QDlqf",
  "chip-icon": "chip-component_chip-icon__6vJgs",
  "error": "chip-component_error__2sXV3",
  "active-on-focus": "chip-component_active-on-focus__6Zm--",
  "chip-text": "chip-component_chip-text__LfXUH",
  "disabled": "chip-component_disabled__qWP3B"
};